<template>
  <section class="bg-grey-oficial py-5">
    <b-container class="pt-4 pb-5">
      <b-row>
        <!-- title -->
        <b-col md="6" class="d-flex flex-column justify-content-center">
          <h1 class="text-purple mb-4">
            Seu carro vale mais,
            <span class="font-weight-light">quando é vendido pela VAAPTY.</span>
          </h1>
          <p
            class="text-purple mb-0"
            v-html="'Veja a experiência real de quem já vendeu com a gente'"
          />
        </b-col>

        <!-- depo -->
        <b-col md="6">
          <carousel
            :responsive="{
              0: {
                items: 1
              },
              960: {
                items: 2
              }
            }"
            :autoplay="true"
            :nav="false"
            :dots="false"
          >
            <div v-for="depo in depoBox" :key="depo.id" class="py-1 px-3 mt-4 w-100">
              <div class="bg-orange p-3 d-flex flex-column align-items-center rounded">
                <!-- avatar -->
                <img
                  :src="require(`@/assets/images/depo/${depo.avatar}`)"
                  class="rounded-circle mb-2 avatar-dimensions"
                />

                <!-- depo text -->
                <p
                  class="text-purple text-center"
                  style="line-height: 18px; font-size: 90%;"
                  v-html="depo.text"
                />

                <!-- name -->
                <p class="text-white text-center font-weight-bold mb-0" v-html="depo.name" />
              </div>
            </div>
          </carousel>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import carousel from "vue-owl-carousel";

export default {
  components: {
    carousel,
  },
  data() {
    return {
      depoBox: [
        {
          avatar: "depoimentos1.jpg",
          text:
            '"Eles fizeram uma proposta de venda rápida e ela realmente aconteceu. Foram boas propostas e se tiver afim de vender eu carro eu indico."',
          name: "Alan",
        },
        {
          avatar: "depoimentos2.jpg",
          text:
            '"Uma empresa séria, idônea e foi muito rápido! Bem além do que eu estava esperando. Sai satisfeito e com certeza indicaria aos colegas e amigos."',
          name: "Francisco",
        },
        {
          avatar: "depoimentos4.jpg",
          text:
            '"Eu vim sem expectativa e acabei vendendo minha moto na mesma hora. Pra quem tá precisando vender rápido é o lugar ideal!"',
          name: "André CBX",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
$dimensions: 90px;
.avatar-dimensions {
  width: #{$dimensions} !important;
  height: #{$dimensions} !important;
}
</style>
